import React, { useState, useEffect, useRef } from "react";
import { FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import ReactModal from "react-modal";
import "../styles/Home.css";
import video1 from "../13/MSP.mp4";
import video2 from "../16/MSP.mp4";
import {
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaClock,
  FaMicrophone
} from "react-icons/fa";

const Home = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const carouselRef = useRef(null);
  const intervalRef = useRef(null);

  // Sample carousel images (replace with your actual images)
  const carouselImages = [
    { id: 1, src: "/carousel/1.jpg", alt: "" },
    { id: 2, src: "/carousel/2.jpg", alt: "" },
    { id: 3, src: "/carousel/3.jpg", alt: "" },
    { id: 4, src: "/carousel/4.jpg", alt: "" },
    { id: 5, src: "/carousel/5.jpg", alt: "" },
    { id: 6, src: "/carousel/6.jpg", alt: "" },
    { id: 7, src: "/carousel/7.jpg", alt: "" },
    { id: 8, src: "/carousel/8.jpg", alt: "" },
    { id: 9, src: "/carousel/9.jpg", alt: "" },
    { id: 10, src: "/carousel/10.jpg", alt: "" },
    { id: 11, src: "/carousel/11.jpg", alt: "" },
    { id: 12, src: "/carousel/12.jpg", alt: "" },
    { id: 13, src: "/carousel/13.jpg", alt: "" },
    { id: 14, src: "/carousel/14.jpg", alt: "" },
    { id: 15, src: "/carousel/15.jpg", alt: "" }
  ];

  // Start auto slide
  const startAutoSlide = () => {
    intervalRef.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 7000);
  };

  // Stop auto slide
  const stopAutoSlide = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  // Handle next slide
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    resetAutoSlide();
  };

  // Handle previous slide
  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + carouselImages.length) % carouselImages.length
    );
    resetAutoSlide();
  };

  // Reset auto slide timer
  const resetAutoSlide = () => {
    stopAutoSlide();
    startAutoSlide();
  };

  // Open image in modal
  const openImageModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    setIsModalOpen(true);
    stopAutoSlide();
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
    startAutoSlide();
  };

  // Initialize carousel
  useEffect(() => {
    startAutoSlide();
    return () => stopAutoSlide();
  }, []);

  const handlePlayVideo = () => {
    setVideoPlaying(true);
    const video = document.querySelector(".hero-video");
    if (video) {
      video.play();
    }
  };

  // Check if mobile on resize
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => {
      window.removeEventListener("resize", checkIfMobile);
    };
  }, []);

  const guests = [
    {
      date: "01.08.2025",
      day: "வெள்ளி",
      name: "ச.கந்தசாமி இ.ஆ.ப., மாவட்ட ஆட்சித் தலைவர் & மாண்புமிகு சு.முத்துசாமி",
      topic: "தொடக்க விழா"
    },
    {
      date: "02.08.2025",
      day: "சனி",
      name: "மருத்துவர் கு.சிவராமன் & மு.இராகவேந்திரன், விஜய் டிவி - தமிழ்ப்பேச்சு எங்கள் மூச்சு நிகழ்வின் வெற்றியாளர்",
      topic: "'மண்ணுயிர் நுண்ணுயிர் உன்உயிர்' 'எனைத்தானும் நல்லவை கேட்க '"
    },
    {
      date: "03.08.2025",
      day: "ஞாயிறு",
      name: "நடுவர் : கலைமாமணி திண்டுக்கல் ஐ.லியோனி",
      topic:
        "'மக்கள் சிந்தனையில் நல்ல மாற்றத்தைப் பெரிதும் தருவது பேச்சா? எழுத்தா? பாட்டா ? திரையா?'"
    },
    {
      date: "04.08.2025",
      day: "திங்கள்",
      name: "சுகி.சிவம் & கே.வைத்தியநாதன் ஆசிரியர் தினமணி நாளிதழ்",
      topic: "'ஊருக்கு நல்லது சொல்வேன்' 'வையத்து வாழ்வாங்கு வாழ்பவர்'"
    },
    {
      date: "05.08.2025",
      day: "செவ்வாய்",
      name: "டாக்டர் ஜி.விஸ்வநாதன் வேந்தர், விஐடி பல்கலைக்கழகம் & வி.டில்லிபாபு இராணுவ விஞ்ஞானி, இந்தியப் பாதுகாப்புத்துறை",
      topic: "'அறிவியல் மேதை ஜி.டி. நாயுடு விருது' வழங்கும் நிகழ்வு கருத்துரை"
    },
    {
      date: "06.08.2025",
      day: "புதன்",
      name: "பேராசிரியர் சொ.சொ.மீ. சுந்தரம் கவிதா ஜவகர்",
      topic: "'நெய்த நூலும் நெய்யாத நூலும் ' இலக்கியத்தில் உயிர் நேயம்'"
    },
    {
      date: "07.08.2025",
      day: "வியாழன்",
      name: "புலவர் செந்தலை ந.கவுதமன் & பாவலர் அறிவுமதி",
      topic: "'புதுக்கருத்தும் பொதுக்கருத்தும்' தமிழருக்கில்லை - தமிழ்'"
    },
    {
      date: "08.08.2025",
      day: "வெள்ளி",
      name: "கவிஞர் ஜோ மல்லூரி விஷ்ணுபுரம் சரவணன் பால சாகித்ய புரஸ்கார் -2025 விருதாளர்",
      topic: "'அறிவை விரிவு செய்..''குழந்தைகளோடு கதையாடு...'"
    },
    {
      date: "09.08.2025",
      day: "சனி",
      name: "கோமல் தியேட்டர் வழங்கும்சிறுகதைகள் மேடையில்...(பிரபல எழுத்தாளர்களின் சிறுகதைகள் நாடகமாக அரங்கேறுகின்றன)",
      topic: "படைப்பாளிகளைப் போற்றுவோம்"
    },
    {
      date: "10.08.2025",
      day: "ஞாயிறு",
      name: "கி.அமர்நாத் ராமகிருஷ்ணா இயக்குநர், இந்திய தொல்லியல் ஆய்வுத்துறை - புதுடில்லி & ரா.விஜயன் மூத்த ஆசிரியர், புதிய தலைமுறை தொலைக்காட்சி",
      topic: "புத்தகம் எனும் பெரும் மரம்"
    },
    {
      date: "11.08.2025",
      day: "திங்கள்",
      name: "கலைமாமணி டி.கே.எஸ்.கலைவாணன் & அரு.நாகப்பன்",
      topic: "வாசிப்பின் வழிகாட்டி"
    },
    {
      date: "12.08.2025",
      day: "செவ்வாய்",
      name: "முனைவர் இறையன்பு ஐஏஎஸ் (ஓய்வு) மேனாள் தலைமைச் செயலாளர், தமிழ்நாடு அரசு",
      topic: "நிறைவு விழா"
    }
  ];

  return (
    <div className="home-container">
      {/* Main Content */}
      <div className={`main-content ${!isMobile ? "with-sidebar" : ""}`}>
        {/* Hero Section */}
        <div className="hero-section">
          <div className="bg-slide bg-1"></div>
          <div className="bg-slide bg-2"></div>
          <div className="bg-slide bg-3"></div>

          <div className="hero-content">
            <h1 className="hero-title">ஈரோடு</h1>
            <h2 className="hero-title2"> புத்தகத் திருவிழா</h2>
            <p className="hero-description">
              2005 ஆம் ஆண்டு முதல் மக்கள் சிந்தனைப் பேரவையால் நடத்தப்படும் ஈரோடு
              புத்தகத் திருவிழா ஒவ்வொரு ஆண்டும் மிகச் சிறப்பாக
              நடைபெற்று வருகிறது.
            </p>
          </div>
        </div>

        {/* Add this video section right after hero-content */}
        <div className="hero-video-section">
          <div className="video-container">
            {!videoPlaying && (
              <button className="play-button-overlay" onClick={handlePlayVideo}>
                ▶ Play Video
              </button>
            )}
            <video
              controls
              className="hero-video"
              autoPlay={videoPlaying}
              muted={!videoPlaying}
              playsInline
            >
              <source src={video1} type="video/mp4" />
            </video>
          </div>
          <div className="video-details">
            <div className="detail-item">
              <FaMapMarkerAlt className="detail-icon" />
              <span>
                இடம்: சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி மைதானம், ஈரோடு
              </span>
            </div>
            <div className="detail-item">
              <FaCalendarAlt className="detail-icon" />
              <span>தேதி: ஆகஸ்ட் 1 முதல் 12 வரை</span>
            </div>
            <div className="detail-item">
              <FaClock className="detail-icon" />
              <span>நேரம்: காலை 11 முதல் இரவு 9.30 வரை</span>
            </div>
            <div className="detail-item">
              <FaMicrophone className="detail-icon" />
              <span>தினமும் மாலை 6 மணிக்கு அறிஞர்களின் சொற்பொழிவு</span>
            </div>
          </div>
        </div>

        <div className="slogans-section">
          <h3 className="slogans-heading">
            'மக்கள் சிந்தனைப் பேரவை' முன்வைக்கும் முப்பெரும் முழக்கங்கள்
          </h3>
          <div className="slogans-container">
            <div className="slogan-card">
              <div className="slogan-number">1</div>
              <div className="slogan-text">இல்லந்தோறும் நூலகம்</div>
            </div>
            <div className="slogan-card">
              <div className="slogan-number">2</div>
              <div className="slogan-text">
                நூலகமில்லா ஊரில் குடியிருக்க வேண்டாம்
              </div>
            </div>
            <div className="slogan-card">
              <div className="slogan-number">3</div>
              <div className="slogan-text">நல்ல நூல்களே நல்ல நண்பர்கள்</div>
            </div>
          </div>
        </div>

        {/* Objectives Section */}
        <section className="objectives-section">
          <div className="objectives-container">
            <h2 className="objectives-heading">
              புத்தகத் திருவிழாவின் நோக்கங்கள்
            </h2>

            <div className="objectives-content">
              <div className="objective-card">
                <div className="objective-icon">1</div>
                <p className="objective-text">
                  வெறும் நூல் வணிகத்தை மட்டுமே அடிப்படையாகக் கொண்டு இப்புத்தகத்
                  திருவிழா நடத்தப்படவில்லை. மாறாக... நல்ல நூல்களை நாட்டு
                  மக்களுக்கு அறிமுகப்படுத்தும் உயர்ந்த நோக்கிலும், அவ்வாறு
                  கிடைக்கப்பெறும் சிறந்த நூல்களை வாசிக்கத் தூண்டும் எண்ணத்திலும்
                  இப்புத்தகத் திருவிழா நடத்தப்படுகிறது.
                </p>
              </div>

              <div className="objective-card">
                <div className="objective-icon">2</div>
                <p className="objective-text">
                  சடங்கு பூர்வமாகவோ, சம்பரதாயத்திற்காகவோ நடத்தப்படாமல் முழுக்க
                  முழுக்க சமுதாய நோக்கிலேயே இப்புத்தகத் திருவிழா
                  நடத்தப்படுகிறது.
                </p>
              </div>

              <div className="objective-card">
                <div className="objective-icon">3</div>
                <p className="objective-text">
                  தமிழர்களுக்கு விசாலமான உலகப்பார்வையை உருவாக்கும் பொருட்டு உலகு
                  தழுவிய இலக்கியங்கள், அரசியல் கருத்துகள், விஞ்ஞானக்
                  கண்டுபிடிப்புகள், வரலாற்றுச் செய்திகள், தொழில்நுட்ப
                  விளக்கங்கள், வணிக அனுபவங்கள், தொழில் வளர்ச்சி ஆலோசனைகள்,
                  வேளாண்மை முயற்சிகள் போன்ற பன்முகத் தலைப்புக்களிலான மிகத் தரமான
                  நூல்களை மக்கள் கரங்களில் தவழச் செய்வது.
                </p>
              </div>

              <div className="objective-card">
                <div className="objective-icon">4</div>
                <p className="objective-text">
                  பட்டப்படிப்பு, பல்வேறு துறைசார்ந்த உயர்பட்டப் படிப்பு மற்றும்
                  ஆராய்ச்சிப் படிப்பிற்குத் தேவையான, தேடினாலும் கிடைக்கப்பெறாத
                  நூல்களை பல்வேறு தரமான வெளியீட்டாளர்களின் மூலம் இப்புத்தகத்
                  திருவிழாவில் மாணவர்களுக்கு கிடைக்க ஏற்பாடு செய்வது.
                </p>
              </div>

              <div className="objective-card">
                <div className="objective-icon">5</div>
                <p className="objective-text">
                  பள்ளி, கல்லூரிகளில் பயிலும் மாணவர்களுக்குப் பாடப் புத்தகங்கள்
                  போக வேறு பொதுவான பயனுள்ள நூல்களை வாசிக்கும் பழக்கத்தை
                  மேம்படுத்துவது. மதிப்பெண்கள் பெறுவது மட்டுமல்லாமல் மனித
                  மதிப்புகளைக் கற்றுக் கொடுக்கும் நூல்களை வாசிக்கும் வழக்கத்தை
                  மாணவர்கள் மத்தியில் அதிகரிப்பது.
                </p>
              </div>

              <div className="objective-card">
                <div className="objective-icon">6</div>
                <p className="objective-text">
                  நம் நாடு பற்றிய கடந்த காலப் பெருமிதத்தையும், நிகழ்கால
                  நிகழ்வுகள் குறித்த கவலையையும், எதிர்காலம் பற்றிய கனவுகளையும்
                  இளைஞர்களின் நெஞ்சங்களில் உருவாக்குவது. எதிர்கால இந்தியா எப்படி
                  இருக்க வேண்டும் என்பது குறித்த ஆழ்ந்த சிந்தனையை
                  உருவாக்குவதோடு, அவ்வாறு கனவில் முகிழ்க்கும் மகிழ்ச்சி நிறைந்த
                  இந்தியாவை நனவில் படைக்க இளைஞர்களையும், மாணவர்களையும் கடுமையாக
                  உழைக்கும் பொருட்டு களமிறக்குவது.
                </p>
              </div>

              <div className="objective-card">
                <div className="objective-icon">7</div>
                <p className="objective-text">
                  கொங்கு மண்டலத்திலுள்ள கல்வி நிலையங்களின் நூலகங்களுக்கு உரிய
                  கழிவுகளுடன் நல்ல நூல்கள் கிடைக்க ஏற்பாடு செய்வது. பொது
                  நூலகங்களில் நல்லுள்ளம் கொண்டவர்களின் உதவிகள் மூலம் ஏராளமான
                  நல்ல நூல்கள் இடம்பெற முயற்சிகள் மேற்கொள்வது.
                </p>
              </div>

              <div className="objective-card">
                <div className="objective-icon">8</div>
                <p className="objective-text">
                  படித்தவர்கள், பட்டம் பெற்றவர்கள், படைப்பாளிகள், மாணவர்கள்,
                  ஆசிரியர்கள் என்பதோடு மட்டுமல்லாமல் அவ்வளவாகக் கல்வியறிவில்லாத
                  பாட்டாளி மக்களும் சாதாரண நிலையிலிருக்கும் சாமானியர்களும் கூட
                  இப்புத்தகத் திருவிழாவை நன்கு பயன்படுத்தி, அவர்களும் நிறைய
                  நூல்கள் வாசித்து உலக அறிவு பெற்றவர்களாக உயர
                  இப்புத்தகத்திருவிழா மூலம் முயற்சிப்பது.
                </p>
              </div>

              <div className="objective-card">
                <div className="objective-icon">9</div>
                <p className="objective-text">
                  புத்தகத் திருவிழாவில் தினம்தோறும் மாலைப்பொழுதில் நடைபெறும்
                  இலக்கியக் கூட்டங்களில் பல்லாயிரம் பேரைப் பங்கேற்க வைத்து,
                  அறிஞர்கள் கூறும் கருத்துக்களைக் கேட்பதன் மூலம் அவர்களுக்கு
                  நூல்கள் குறித்த ஈடுபாட்டை ஏற்படுத்த முயற்சிப்பது.
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className="guest-container">
          <h2>புத்தகத் திருவிழா 2025 - சிறப்பு விருந்தினர்</h2>

          {/* Desktop Table */}
          <div className="desktop-table">
            <table className="guest-table">
              <thead>
                <tr>
                  <th>தேதி</th>
                  <th>விருந்தினர்</th>
                  <th>தலைப்பு</th>
                </tr>
              </thead>
              <tbody>
                {guests.map((guest, index) => (
                  <tr key={index}>
                    <td>
                      {guest.date} ({guest.day})
                    </td>
                    <td>{guest.name}</td>
                    <td>{guest.topic}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="mobile-cards">
            {guests.map((guest, index) => (
              <div key={index} className="guest-card">
                <div className="card-date">
                  {guest.date} ({guest.day})
                </div>
                <div className="card-field">
                  <span className="card-label">விருந்தினர்: </span>
                  {guest.name}
                </div>
                <div className="card-field">
                  <span className="card-label">தலைப்பு: </span>
                  {guest.topic}
                </div>
              </div>
            ))}
          </div>
        </div>

        <section className="carousel-sectionhm">
          {/* <h2 className="carousel-headinghm">புத்தகத் திருவிழா நினைவுகள்</h2> */}
          <div
            className="carousel-containerhm"
            ref={carouselRef}
            onMouseEnter={stopAutoSlide}
            onMouseLeave={startAutoSlide}
          >
            <button className="carousel-buttonhm prev" onClick={prevSlide}>
              <FaChevronLeft />
            </button>

            <div
              className="carousel-trackhm"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {carouselImages.map((image, index) => (
                <div
                  key={image.id}
                  className={`carousel-slidehm ${
                    index === currentSlide ? "active" : ""
                  }`}
                  onClick={() => openImageModal(image.src)}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="carousel-imagehm"
                    loading="lazy"
                  />
                  <div className="slide-captionhm">{image.alt}</div>
                </div>
              ))}
            </div>

            <button className="carousel-buttonhm next" onClick={nextSlide}>
              <FaChevronRight />
            </button>

            <div className="carousel-indicatorshm">
              {carouselImages.map((_, index) => (
                <button
                  key={index}
                  className={`indicatorhm ${
                    index === currentSlide ? "active" : ""
                  }`}
                  onClick={() => {
                    setCurrentSlide(index);
                    resetAutoSlide();
                  }}
                />
              ))}
            </div>
          </div>
        </section>

        <div className="vertical-video-section">
          <h2 className="section-title">
            With the lyrics of Vairamuthu sir about our book festival that the miracle of the book and him unite happens when a reader enters the book 21st Annual Erode Book Festival 2025 conducted by Tamil Nadu Government and People's Thought Council Erode
          </h2>
          <div className="vertical-video-container">
            <video controls className="vertical-video" muted playsInline>
              <source src={video2} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        {/* Full Screen Image Modal */}
        <ReactModal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          className="image-modalhm"
          overlayClassName="image-modal-overlayhm"
          ariaHideApp={false}
        >
          <button className="modal-closehm" onClick={closeModal}>
            <FaTimes />
          </button>
          <img
            src={selectedImage}
            alt="Full screen"
            className="modal-imagehm"
          />
        </ReactModal>
      </div>
    </div>
  );
};

export default Home;
